import {customElement, property} from 'lit/decorators.js';
import {css, html, LitElement} from 'lit';
import {repeat} from 'lit-html/directives/repeat.js';
import {translate} from '@stefanholzapfel/lit-translate';
import {unsafeCSSIcon} from '../../../styles/icons';
import {pipe} from '../../../directives/pipe.directive';
import {LocaleDatePipe} from '../../../pipes/locale-date.pipe';
import {SpImageService} from '../../../services/sp-image.service';
import {when} from 'lit/directives/when.js';
import {SpPipeService} from '../../../services/sp-pipe.service';

@customElement('sp-statistic-slide-spot-ranking')
export class SpStatisticSlideSpotRanking extends LitElement {
    @property({type: Array})
    data: SpStatisticSpotRankingEntry[] = [];
    @property({type: Function})
    linkContent?: (contentType, contentId) => void;
    @property({type: Boolean})
    loading: Boolean;

    static styles = [
        // perfectScrollbar,
        //language=CSS
        css`
            ul {
                padding: 0 0 15px 0;
                margin: 0;
            }

            ul li {
                position: relative;
                height: 60px;
                width: auto;
                overflow: hidden;
                display: block;
                margin-top: 10px;
                border-top: 1px solid #ddd;
            }

            ul li:first-child {
                border: 0;
                margin-top: 0;
            }

            ul li:last-child {
                margin-bottom: 10px;
            }

            ul li .pos {
                position: absolute;
                left: 20px;
                top: 15px;
                width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 20px;
                background-color: #b7b7b7;
                border-radius: 20px;
                color: #fff;
            }

            ul li .pos-1,
            ul li .pos-2,
            ul li .pos-3 {
                left: 15px;
                top: 10px;
                width: 50px;
                height: 50px;
                line-height: 45px;
                box-sizing: border-box;
                padding-top: 5px;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 50px auto;
                background-color: transparent;
                border-radius: 0;
            }

            ul li .pos-1 {
                background-image: url(${unsafeCSSIcon('star-gold', {size: 'x128', color: 'colored'})});
            }

            ul li .pos-2 {
                background-image: url(${unsafeCSSIcon('star-silver', {size: 'x128', color: 'colored'})});
            }

            ul li .pos-3 {
                background-image: url(${unsafeCSSIcon('star-bronze', {size: 'x128', color: 'colored'})});
            }

            ul li .image {
                display: block;
                position: absolute;
                right: 10px;
                top: 10px;
                width: 50px;
                height: 50px;
                background-color: #D6D6D0;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                border-radius: 5px;
                cursor: pointer;
            }

            ul li .text {
                position: absolute;
                left: 80px;
                top: 10px;
                bottom: 0;
                right: 70px;
            }

            ul li .text span {
                display: block;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
            }

            ul li .text span.name {
                height: 18px;
                line-height: 18px;
                font-size: 14px;
                cursor: pointer;
            }

            ul li .text span.total {
                font-weight: bold;
                height: 16px;
                line-height: 16px;
                font-size: 12px;
                cursor: pointer;
            }

            ul li .text span.latest {
                height: 16px;
                line-height: 16px;
                font-size: 12px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            ul li .text span.latest span {
                display: inline;
                color: rgba(var(--sp-color-a));
                cursor: pointer;
            }

            .no-data {
                padding: 15px;
            }
        `
    ];

    // updated(_changedProperties: PropertyValues) {
    //        dispatchUpdateScrollbarsEvent(this, true);
    // }

    render() {
        return html`
            ${when(!this.loading && (!this.data || this.data.length == 0), () => html`
                <div class="no-data">
                    ${translate('STATISTICS_NO_DATA')}
                </div>
            `)}
            ${when(this.data && this.data.length, () => html`
                <ul>
                    ${repeat(this.data ? this.data : [], (entry) => entry.spot_root_id, (entry, index) => html`
                        <li>
                            <div class="pos pos-${entry.pos}">${entry.pos}</div>
                            <div class="text">
                                <span class="name"
                                      @click=${() => this.linkContent('spot', entry.spot_id)}>${entry.label}</span>
                                <span class="total"
                                      @click=${() => this.linkContent('spot', entry.spot_id)}>${translate('STATISTICS_COUNT_UPDATES')}
                                    : ${entry.count}</span>
                                <span class="latest">
                                    ${translate('STATISTICS_SPOT_RANKING_LATEST', {
                                        date: SpPipeService.applyPipes(entry.spot_spotted_at, [{pipe: new LocaleDatePipe()}])
                                        // date: pipe(entry.spot_spotted_at, [{pipe: new LocaleDatePipe()}])
                                    })} 
                                    <span @click=${() => this.linkContent('user', entry.spot_spotted_by)}>${entry.spot_spotted_by_display_name}</span>
                                </span>
                            </div>
                            <sp-image class="image" @click=${() => this.linkContent('spot', entry.spot_id)}
                                      .image=${entry.spot_image ? SpImageService.buildUrl('spots', 'thumbs', entry.spot_image, 'x200') : null}
                                      .showSpinner=${false}
                                      .placeholderImage=${SpImageService.getPlaceholderUrl('spots')}>
                            </sp-image>
                        </li>
                    `)}
                </ul>
            `)}
        `;
    }
}

export interface SpStatisticSpotRankingEntry {
    spot_id: number;
    spot_root_id: number;
    spot_image: string;
    spot_category: number;
    spot_spotted_at: Date;
    spot_spotted_by: number;
    spot_spotted_by_display_name: string;
    count: number;
    pos: number;
    label: string;
}